import type { FaireProductEntity } from "../../entity_types/product";

export const p_6bvhqf29gr: FaireProductEntity = {
  token: "p_6bvhqf29gr",
  type: "product",
  name: "STAY AWAY! bug spray | lice prevention spray | natural lice repellant spray | Rosemary repel spray | School lice prevention | Organic bug",
  brandToken: "b_6r1eum8lfs",
  brandName: "Wonderfully Made .love",
  imageUrl:
    "https://cdn.faire.com/fastly/c65e3013dabdbd7cd646595dc8a2c4593e01f15cb188dbf84afb68e0307d48cd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/83614f2a1030923079ab3946f771d09f4bc93da21e972266fcbfaad30f16604b.jpeg",
    "https://cdn.faire.com/fastly/9b22f075f9bf70756d018b3080d9975265fb41d03bde3d72c2912a32177c834e.jpeg",
    "https://cdn.faire.com/fastly/3a5991bc331c6a44f52724dab2bb371433b91f2071908ef74a294c5579876330.jpeg",
  ],
  priceDollars: 13.3,
  description:
    "Bugs don't discriminate! Be protected with this all-natural back to school necessity!! Give yourself peace of mind by sending your kids to school with a barrier of protection...from those lice outbreaks!\n\nWhen heading to the soccer fields, know you & your littles will be protected from ticks and mosquitoes, all naturally!!\n\nAll natural, organic, and non-toxic ingredients! You'll love the smell but lice & other bugs hate it!\n\nComes in 8 fl oz. Spray bottle.\n\nThis is 2x more effective than the leading lice repellants in the stores! It has been scientifically proven that Melaleuca and Lavender essential oils kill and repel 100% of lice!\n\nDirections: Shake well and spray liberally onto skin, backpacks, and clothing. Feel better knowing you're protected! Thank you for your support! If you have any questions feel free to contact me!\n",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:23.954Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
